import {_rails} from '../../modules/constants'
import {stringify} from 'querystring';
export default class events_checkout extends EventedClass {
    constructor() {
        super();
        this.current_cart_id = window.crt_id
        this.order_id = 0
        this.elem = {
            step:$('.wiz-progressbar'),
            discounts: $('.discounts'),
            totals: $('.total-badge'),
            selects_discount: $('.form-select'),
            btn_validate: $('#btn-validate-cart'),
            btn_process: $('#btn-process-cart'),
            alert_cart_error: $('#cart-error')
        }
        // CALLING INSTALL
        this.initialize();
    }

    initialize() {
        // BLOCKED BUTTON IF NOT EXIST EVENT OR VALID CART
        if (window.lck_buy) this.lockBuyButtons()
        this._installEvents()
    }
    _installEvents() {
        // VALIDAR
        this.elem.btn_validate.on('click',this._onClickValidate.bind(this))
        // PAGAR
        this.elem.btn_process.on('click',this._onClickProcess.bind(this))
    }
    _onClickValidate(e){
        try{
            let payload = {discounts:[]}
            this.elem.selects_discount.each((index, select)=>{
                const discount_id = $(select).val() || "0"
                const ticket_id = $(select).parent().parent('.discounts__ticket').data('id') || "0"
                if (discount_id != "0"){
                    payload.discounts.push({"ticket_id": ticket_id, "discount_id": discount_id})
                }
            })
            // COUNT
            if (payload.discounts.length >0 ){
                // ENVIEM LA DATA PER COMPROVACIONS I DESCOMPTES
               this._fetchValidateDiscounts(payload)
            }else{
                // NO HI HAN DESCOMPTES; PASEM AL BUTÓ DE PAGAMENT
                this.elem.selects_discount.attr('disabled', 'disabled')
                this.elem.btn_validate.addClass('hide')
                this.elem.btn_process.removeClass('hide')
            }
        }catch (e) {
            console.error(e)
            App.utils.notify.error(App.messages.global.errorAjax, 'Error', {
                timeOut: 3000,
                positionClass: 'toast-top-full-width',
                preventDuplicates: true
            })
        }

    }
    _onClickProcess(e){
        let payload, self;
        self = this;
        this._pedido();
        payload = stringify({
            cart_id: this.current_cart_id,
            order_id: this.order_id,
            widget: 1
        });
        App.utils.loaderON();
        Rails.ajax({
            url: _rails.url.payment_form,
            type: 'POST',
            data: payload,
            success: function(data) {
                let $form;
                if (typeof data === 'object') {
                    // body height to 600px
                    $(document.body).height("650px");
                    $form = $('form#frm_payment');
                    $form.children('[name=\'Ds_MerchantParameters\']').val(data.Ds_MerchantParameters);
                    $form.children('[name=\'Ds_Signature\']').val(data.Ds_Signature);
                    $form[0].submit();
                } else {
                    console.error('Invalid data payment', data);
                }
            },
            error: function(response) {
                if (response.hasOwnProperty('cart_not_found')) {
                    self.elem.discounts.remove()
                    self.elem.alert_cart_error.html(response.cart_not_found).removeClass('hide')
                    self.lockBuyButtons()
                }else if (response.hasOwnProperty('cart_not_payable')) {
                    self.elem.discounts.remove()
                    self.elem.alert_cart_error.html(response.cart_not_payable).removeClass('hide')
                    self.lockBuyButtons()
                }else if (response.hasOwnProperty('cart_cancelled')) {
                    self.elem.discounts.remove()
                    self.elem.alert_cart_error.html(response.cart_cancelled).removeClass('hide')
                    self.lockBuyButtons()
                }else {
                    console.error('Error cart', response);
                    App.utils.notify.error(App.messages.global.redsys.ca.error, 'Error de pagament', {
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        preventDuplicates: true
                    });
                }
            },
            complete: function() {
                App.utils.loaderOFF();
            }
        });
    }
    _pedido() {
        let tmp;
        tmp = 1000 + Math.floor(Math.random() * 9000) + this.current_cart_id;
        this.order_id = tmp.toString().substr(0, 12);
        console.log(this.order_id);
        return this.order_id;
    }
    /*** FETCH DATA ; POST ***/
    _fetchValidateDiscounts(data){
        const self = this
        const payload = data //JSON.stringify(data)|| {};
        App.utils.loaderON();
        Rails.ajax({
            url: _rails.url.discounts_validate_cart,
            type: 'POST',
            beforeSend: (xhr, options) => {
                xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
                // Workaround: add options.data late to avoid Content-Type header to already being set in stone
                // https://github.com/rails/rails/blob/master/actionview/app/assets/javascripts/rails-ujs/utils/ajax.coffee#L53
                options.data = JSON.stringify(payload)
                return true
            },
            success: function(data) {
                // LOOP
                data.forEach((item, index, arr) => {
                    const $ticket = self.elem.discounts.find(`.discounts__ticket[data-id="${item.id}"]`)
                    if (!!$ticket.length) {
                        // TODO: busco discount_percentage_number > 0
                        const css = (item.amount_base !== item.amount_real_with_currency) ? "color:orange;" : "";
                        //const percent = parseInt(item.discount_percentage.replace("%", "")) > 0 ? '-' + item.discount_percentage : ""
                        $ticket.find('.price').html(`<span style="${css}">${item.amount_real_with_currency}</span>`)
                        $ticket.find('.description').html(`${item.discount_name}`)
                        self.elem.totals.html(`TOTAL: ${item.total_and_count_with_currency}`)
                    }
                })
                // HABILITEM BUTÓ DE PAGAR
                self.elem.btn_validate.addClass('hide')
                self.elem.btn_process.removeClass('hide')

            },
            error: function(response, statusText, xhr) {
                if (response.hasOwnProperty('cart_not_found')) {
                    self.elem.discounts.remove()
                    self.elem.alert_cart_error.html(response.cart_not_found).removeClass('hide')
                    self.lockBuyButtons()
                }else if (response.hasOwnProperty('cart_cancelled')){
                    self.elem.discounts.remove()
                    self.elem.alert_cart_error.html(response.cart_cancelled).removeClass('hide')
                    self.lockBuyButtons()
                }else{
                    console.error('Error validate', e);
                    App.utils.notify.error(App.messages.global.errorAjax, 'Error de validació', {
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        preventDuplicates: true
                    });
                }
            },
            complete: function() {
                App.utils.loaderOFF();
            }
        });
    }
    lockBuyButtons(){
        this.elem.btn_validate.addClass('disabled').attr("disabled", true)
        this.elem.btn_process.addClass('disabled').attr("disabled", true)
    }
}